import { useQuery } from '@tanstack/react-query'
import Checkpoint from '../../model/Checkpoint'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const CHECKPOINTS_QUERY_KEY = (challengeID: string) => ['checkpoints', challengeID] as const

export function useCheckpoints() {
  const challengeID = useChallengeId()

  return useQuery<Checkpoint[]>({
    queryKey: CHECKPOINTS_QUERY_KEY(challengeID),
    queryFn: () => dataSource.getCheckpoints(challengeID),
    enabled: !!challengeID,
  })
}
